import { render, staticRenderFns } from "./taxpayers-icon.vue?vue&type=template&id=136e666d"
import script from "./taxpayers-icon.vue?vue&type=script&lang=js"
export * from "./taxpayers-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports